import type { components } from '@/api'
import { invariant } from '@/shared/utils/typeAssertions'
import type { ResourceMember } from './types'

export const serializeResourceMember = (
  member: components['schemas']['Users.ResourceMemberResponse'],
): ResourceMember => {
  invariant(typeof member.user === 'object' && 'email' in member.user)

  return {
    id: member.user.id,
    email: member.user.email,
    firstName: member.user.first_name,
    lastName: member.user.last_name,
    fullName: [member.user.first_name, member.user.last_name].filter(Boolean).join(' ') || null,
    role: member.role,
    lastActive: member.user.last_activity_at,
    profilePictureUrl: member.user.profile_picture_url,
    missingAccess:
      member.missing_access?.map(({ resource_key, resource_type }) => ({
        id: resource_key,
        resourceType: resource_type,
      })) || [],
  }
}
